import { useQuery } from "@tanstack/react-query";
import { StringifiableRecord } from "query-string";
import { useCallback } from "react";

import { ExecuteData, useApi } from "../../useApi";

import {
  IGetProductsResponse,
  IUseGetProductsProps
} from "./useGetProducts.types";

import { useAuth } from "@/core/libs/use-auth";
import { useSelectedBu } from "@/hooks/useSelectedBu";

const PRODUCTS_QUERY_TOKEN = "products";

export const useGetProducts = (
  props?: IUseGetProductsProps
): IGetProductsResponse => {
  const { execute } = useApi();
  const { isAuthenticated } = useAuth();
  const { selectedBU } = useSelectedBu();

  const paramValues = {
    businessActionId: selectedBU?.id,
    all: true,
    page: 1,
    limit: props?.params?.limit || 10,
    ...props?.params
  };

  const fetchData = useCallback(
    async (params: StringifiableRecord) => {
      try {
        const data: ExecuteData = {
          params,
          url: "admin/products",
          messages: {
            error: "Tivemos um problema ao carregar os produtos"
          }
        };

        return await execute(data);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
        throw error;
      }
    },
    [execute]
  );

  const { data, isFetching } = useQuery({
    queryKey: [PRODUCTS_QUERY_TOKEN, paramValues],
    queryFn: () => fetchData(paramValues),
    enabled: isAuthenticated,
    placeholderData: prev => prev,
    refetchOnWindowFocus: false
  });

  return {
    productsList: data?.data,
    isLoadingProductsList: isFetching
  };
};
